module.exports = __webpack_public_path__ + "060b0df162bf99be77ed14a433ead609.svg";